/* eslint-disable */
export default function headerHoverFix() {
  const topNavLinks = document.querySelectorAll('.header-navigation > li > a');
  topNavLinks.forEach((link) => {
    link.setAttribute('data-text', link.textContent);
  })
}
